import { copyAllProperties } from "./utils";
import BaseObject from "./BaseObject";
import GroupAddress from "./GroupAdress";
import type Channel from "./Channel";
import BaseModel from "./BaseModel";
import SignalTreeViewModel from "../modelTreeViews/SignalTreeviewModel";
import SignalTypes, { descriptionForSignalType } from "./SignalTypes";
import { nameToShortName } from "../models/utils";

import Logger from "../Logger";
const logger = new Logger();

//////////////////////////////////////////////////
import ObjectFactory from "./ObjectFactory";
import ReferenceArray from "./ReferenceArray";
import { ChannelDescriptionProperty, ChannelTypeProperty } from "./Channel";
import { KnxSceneNumberProperty } from "./ButtonChannel";
import SignalType from "./SignalType";
import { itx, noItx } from "../translationItx/itx";
import { createGlobalAddresses } from "../addressGeneration/createGlobalAddresses";
import UndoStep from "../undomanager/UndoStep";
import type Consumer from "./Consumer";
import { isDevelopmentEnvironment } from "../estada-config";
import { ensureSignalInManualChannel } from "../components/ConnectSignal";
import Device from "./Device";
import ErrorItems from "./ErrorItems";
import showSignalConnectionDialog from "../modelDialogs/showSignalConnectionDialog";
ObjectFactory.registerClass("Signal", (data?: any, parent?: BaseModel) => {
  return new Signal(data, parent);
});
//////////////////////////////////////////////////

export enum MatchType {
  Full = 0,
  Raw = 1,
  Text = 2,
  Display = 3,
  mod = 4,
}

export default class Signal extends BaseModel {
  public get className(): string {
    return "Signal"; // no itx
  }

  getParentCollectionName(): string | undefined {
    return "signals"; // no itx
  }

  // persistent properties

  // -----------------------------------------------------------------------------
  // type
  // -----------------------------------------------------------------------------
  _type = SignalTypes.Unknown;
  set type(newValue: SignalType) {
    this.beforeChange("type");
    this._type = newValue;

    this.changed("type");
  }
  get type(): SignalType {
    return this._type;
  }
  oldType = SignalTypes.Unknown;
  // -----------------------------------------------------------------------------
  // groupAddresses
  // -----------------------------------------------------------------------------
  _groupAddresses = new ReferenceArray<GroupAddress>();
  get groupAddresses(): ReferenceArray<GroupAddress> {
    return this._groupAddresses;
  }

  set groupAddresses(newValue: ReferenceArray<GroupAddress>) {
    if (this._groupAddresses === newValue) return;
    this.beforeChange("groupAddresses");
    this._groupAddresses = newValue;
    this.changed("groupAddresses");
  }

  // -----------------------------------------------------------------------------
  // instanceId
  // -----------------------------------------------------------------------------
  _instanceId: string | undefined;
  get instanceId(): string | undefined {
    return this._instanceId;
  }

  set instanceId(newValue: string | undefined) {
    if (this._instanceId === newValue) return;
    this.beforeChange("instanceId");
    this._instanceId = newValue;
    this.changed("instanceId");
  }

  // -----------------------------------------------------------------------------

  lastGroupAddresses?: ReferenceArray<GroupAddress>; // only for AdressGeneration

  // -----------------------------------------------------------------------------
  // number
  // -----------------------------------------------------------------------------
  _number = "";
  get number(): string {
    return this._number;
  }

  set number(newValue: string) {
    if (this._number === newValue) return;
    this.beforeChange("number");
    this._number = newValue;
    this.changed("number");
  }

  // -----------------------------------------------------------------------------
  // knxId
  // -----------------------------------------------------------------------------
  _knxId = "";
  get knxId(): string {
    return this._knxId;
  }

  set knxId(newValue: string) {
    if (this._knxId === newValue) return;
    this.beforeChange("knxId");
    this._knxId = newValue;
    this.changed("knxId");
  }

  // -----------------------------------------------------------------------------
  // knxName
  // -----------------------------------------------------------------------------
  _knxName = "";
  get knxName(): string {
    return this._knxName;
  }

  set knxName(newValue: string) {
    if (this._knxName === newValue) return;
    this.beforeChange("knxName");
    this._knxName = newValue;
    this.changed("knxName");
  }

  // -----------------------------------------------------------------------------
  // knxTextEN
  // -----------------------------------------------------------------------------
  _knxTextEN = "";
  get knxTextEN(): string {
    return this._knxTextEN;
  }

  set knxTextEN(newValue: string) {
    if (this._knxTextEN === newValue) return;
    this.beforeChange("knxTextEN");
    this._knxTextEN = newValue;
    this.changed("knxTextEN");
  }

  // -----------------------------------------------------------------------------
  knxTextENForDetection_Template?: string; // only for detection
  knxTextENForDetectionRaw?: string; // only for detection (mapSignalToTag Script)

  // -----------------------------------------------------------------------------
  // knxFunctionText
  // -----------------------------------------------------------------------------
  _knxFunctionText = "";
  get knxFunctionText(): string {
    return this._knxFunctionText;
  }

  set knxFunctionText(newValue: string) {
    if (this._knxFunctionText === newValue) return;
    this.beforeChange("knxFunctionText");
    this._knxFunctionText = newValue;
    this.changed("knxFunctionText");
  }

  // -----------------------------------------------------------------------------
  // knxFunctionTextOrg
  // -----------------------------------------------------------------------------
  _knxFunctionTextOrg = "";
  get knxFunctionTextOrg(): string {
    return this._knxFunctionTextOrg;
  }

  set knxFunctionTextOrg(newValue: string) {
    if (this._knxFunctionTextOrg === newValue) return;
    this.beforeChange("knxFunctionTextOrg");
    this._knxFunctionTextOrg = newValue;
    this.changed("knxFunctionTextOrg");
  }

  // -----------------------------------------------------------------------------
  // knxFunctionTextEN
  // -----------------------------------------------------------------------------
  _knxFunctionTextEN = "";
  get knxFunctionTextEN(): string {
    return this._knxFunctionTextEN;
  }

  set knxFunctionTextEN(newValue: string) {
    if (this._knxFunctionTextEN === newValue) return;
    this.beforeChange("knxFunctionTextEN");
    this._knxFunctionTextEN = newValue;
    this.changed("knxFunctionTextEN");
  }

  // -----------------------------------------------------------------------------

  knxChannelTypeProperty?: ChannelTypeProperty;
  knxSceneNumberProperty?: KnxSceneNumberProperty;

  //
  // nicht persistent, für etsImport
  //

  // -----------------------------------------------------------------------------
  // knxRefId
  // -----------------------------------------------------------------------------
  _knxRefId?: string;
  get knxRefId(): string | undefined {
    return this._knxRefId;
  }

  set knxRefId(newValue: string | undefined) {
    if (this._knxRefId === newValue) return;
    this.beforeChange("knxRefId");
    this._knxRefId = newValue;
    this.changed("knxRefId");
  }

  // -----------------------------------------------------------------------------
  // knxChannelId
  // -----------------------------------------------------------------------------
  _knxChannelId?: string;
  get knxChannelId(): string | undefined {
    return this._knxChannelId;
  }

  set knxChannelId(newValue: string | undefined) {
    if (this._knxChannelId === newValue) return;
    this.beforeChange("knxChannelId");
    this._knxChannelId = newValue;
    this.changed("knxChannelId");
  }

  // -----------------------------------------------------------------------------

  a?: any; /// data.a from KnxParameterViewer during loading

  // -----------------------------------------------------------------------------
  // knxDatapointType
  // -----------------------------------------------------------------------------
  private _knxDatapointType = "";
  public get knxDatapointType(): string {
    return this._knxDatapointType;
  }
  public set knxDatapointType(value: string) {
    this.beforeChange("knxDatapointType");
    if (this._knxDatapointType != value) {
      logger.log(`signal- set knxDatapointType ${this.number}: ${this._knxDatapointType} -> ${value}`);
      this._knxDatapointType = value || "";
    }

    this.changed("knxDatapointType");
  }

  // -----------------------------------------------------------------------------
  // knxNestedName
  // -----------------------------------------------------------------------------
  _knxNestedName = "";
  get knxNestedName(): string {
    return this._knxNestedName;
  }

  set knxNestedName(newValue: string) {
    if (this._knxNestedName === newValue) return;
    this.beforeChange("knxNestedName");
    this._knxNestedName = newValue;
    this.changed("knxNestedName");
  }

  // -----------------------------------------------------------------------------
  // determinedFromId
  // -----------------------------------------------------------------------------
  _determinedFromId = "";
  get determinedFromId(): string {
    return this._determinedFromId;
  }

  set determinedFromId(newValue: string) {
    if (this._determinedFromId === newValue) return;
    this.beforeChange("determinedFromId");
    this._determinedFromId = newValue;
    this.changed("determinedFromId");
  }

  // -----------------------------------------------------------------------------

  //////////////////////////////////////////////////

  constructor(data?: any, parent?: BaseObject) {
    super(data, parent);
    copyAllProperties(data, this);
    logger.log("signal- constructor", data);
    this.treeViewModel = new SignalTreeViewModel(this);
  }

  get knxTextENForDetection(): string {
    // only for detection

    if (this.knxTextENForDetection_Template) {
      const p = this.parentDevice;
      if (p) {
        return p.substitutePropertyPlaceholders(this.knxTextENForDetection_Template, this.instanceId);
      }
    }

    return "";
  }

  get parentDevice(): Device | undefined {
    if (this.parent?.parent) {
      return this.parent.parent as Device;
    }
    return undefined;
  }

  getTag(): string | undefined {
    if (this.parent?.className == "Consumer") {
      return "";
    } else {
      if (this.number === "") {
        return "(?)";
      } else {
        return `${this.number}`;
      }
    }
  }

  getFullTagParts(): Array<any> {
    try {
      var res: any = [];

      const channel = this.parent as Channel;

      if (channel) {
        if (channel.parent) {
          res = channel.parent.getFullTagParts();
        }

        // if (channel.knxChannel) {
        //   res.push({ prefix: channel.getTagPrefix(), tag: channel.knxChannel.shortName2, obj: channel });
        // }
      }

      res.push({ prefix: this.getTagPrefix(), tag: this.tag, obj: this });

      return res;
    } catch (ex) {
      logger.error(ex);
    }

    return [];
  }

  //////////////////////////////////////////////////
  getErrors(): ErrorItems | undefined {
    // because of request signals dauerschleife
    // merge request signal and own
    let errors1 = this._errors;
    let errors2 = this.requestSignal?._errors;
    if (errors1 || errors2) {
      let mergedErrors: ErrorItems = {};
      if (errors1) {
        mergedErrors = { ...mergedErrors, ...errors1 };
      }
      if (errors2) {
        mergedErrors = { ...mergedErrors, ...errors2 };
      }
      if (Object.keys(mergedErrors).length == 0) {
        return undefined;
      }
      return mergedErrors;
    }

    return undefined;
  }

  //////////////////////////////////////////////////

  getPersistentProperties(): string[] {
    return [
      "_type", // no itx
      "groupAddresses", // no itx
      "number", // no itx
      "knxId", // no itx
      "knxName", // no itx
      "knxTextEN", // no itx
      "knxFunctionText", // no itx
      "knxFunctionTextOrg", // no itx
      "knxFunctionTextEN", // no itx
      "knxDatapointType", // no itx
      "knxNestedName", // no itx
      "determinedFromId", // no itx

      "knxRefId",
      "knxChannelId", // temporär zum debuggen des etsImports no itx
      "instanceId",

      ...super.getPersistentProperties(),
    ];
  }

  ///////////////////////////////////////////////////////////

  // only for metadataProcessing in KnxParameterViewer

  isChannelIndependent?: boolean;

  ///////////////////////////////////////////////////////////

  // -----------------------------------------------------------------------------
  // knxChannelDescriptionProperty
  // -----------------------------------------------------------------------------
  private _knxChannelDescriptionProperty: ChannelDescriptionProperty | undefined;
  public get knxChannelDescriptionProperty(): ChannelDescriptionProperty | undefined {
    return this._knxChannelDescriptionProperty;
  }
  public set knxChannelDescriptionProperty(value: ChannelDescriptionProperty | undefined) {
    if (!value?.id) {
      value = undefined;
    }

    this._knxChannelDescriptionProperty = value;
  }

  // -----------------------------------------------------------------------------
  ///////////////////////////////////////////////////////////

  rawSceneData: Array<any> | undefined;

  get channelName(): string {
    const re = new RegExp(/channel *(\w*)/i);

    if (this.knxTextENForDetectionRaw) {
      const match = re.exec(this.knxTextENForDetectionRaw);
      if (match && match[1]) {
        return match[1];
      }
    }

    if (this.knxTextENForDetection) {
      const match = re.exec(this.knxTextENForDetection);
      if (match && match[1]) {
        return match[1];
      }
    }

    if (this.knxFunctionTextEN) {
      const match = re.exec(this.knxFunctionTextEN);
      if (match && match[1]) {
        return match[1];
      }
    }

    return nameToShortName(this.name);
  }

  ////////////////////////////////////////////////////////////////////

  async loadFromEstadaStorage(
    data: any | undefined,
    parent: BaseModel | undefined,
    loadData: (id: string | undefined, parentId: string | undefined) => any,
  ): Promise<boolean> {
    const res = await super.loadFromEstadaStorage(data, parent, loadData);
    return res;
  }

  undelete() {
    super.undelete();
    const channel = this.parent as Channel;
    if (channel) {
      channel.signals.add(this);
    }

    this.groupAddresses.items.forEach((ga) => {
      ga.addSignalBackpointer(this);
    });
  }

  delete(): Array<BaseObject> {
    this.groupAddresses.items.forEach((ga) => {
      ga.removeSignalBackpointer(this);
    });

    const res = super.delete();
    return res;
  }

  /////////////////////////////////////////////////////
  //
  // override name property
  //
  get name(): string {
    if (!state.isLoadingFromEstadaStorage) {
      if (this._name) {
        const p = this.parentDevice;
        if (p?.isDevice) {
          return p.substitutePropertyPlaceholders(this._name, this.instanceId);
        }
      } else {
        return descriptionForSignalType(this.type);
      }
    }

    return this._name || "";
  }

  set name(newValue) {
    this.beforeChange("name");
    this._name = newValue;

    this.changed("name");
  }

  //
  canBeDeletedInteractive(): boolean {
    return false;
  }

  canBeEditedInteractive(): boolean {
    return false;
  }

  get isDummySignal(): boolean {
    return this.name.indexOf("DUMMY") >= 0 || this.number.indexOf(".") >= 0;
  }

  get requestSignal(): Signal | undefined {
    let res: Signal | undefined;

    const parentKnxChannel = this.parent as Channel;

    if (parentKnxChannel.isRequestChannel) {
      return this;
    }
    if (!parentKnxChannel.isChannel) {
      return this;
    }

    parentKnxChannel?.assetIsKnxChannel();

    const parentRequestChannel = parentKnxChannel?.requestChannel;
    if (parentRequestChannel) {
      res = parentRequestChannel.signals.findFirst((s) => s.number == this.number);
      if (!res) {
        const newRequestSignal = this.simpleCopy();
        newRequestSignal.parent = parentRequestChannel;
        // Use addWithoutUpdate to avoid firing N event cascades when rendering many signal rows.
        // The signal is still in the map for all subsequent findFirst() lookups.
        parentRequestChannel.signals.addWithoutUpdate(newRequestSignal);
        res = newRequestSignal;
      }
    } else {
      logger.error(`parentRequestChannel == undefined for ${this.fullTag}`);
    }

    return res;
  }

  get knxSignal(): Signal | undefined {
    let res: Signal | undefined;

    const parentChannel = this.parent as Channel;
    parentChannel?.assetIsRequestChannel();

    const parentKnxChannel = parentChannel?.knxChannel;
    if (parentKnxChannel) {
      res = parentKnxChannel.signals.findFirst((s) => s.number == this.number);
    } else {
      logger.error(`parentKnxChannel == undefined for ${this.fullTag}`);
    }

    return res;
  }

  simpleCopy(): Signal {
    const copyOfSignal = new Signal({}, undefined);
    copyOfSignal.tag = this.tag;
    copyOfSignal.instanceId = this.instanceId;
    copyOfSignal._name = this._name;
    copyOfSignal.type = this.type;
    copyOfSignal.number = this.number;
    copyOfSignal.knxId = this.knxId;
    copyOfSignal.knxFunctionText = this.knxFunctionText;
    return copyOfSignal;
  }

  copyGroupAddressesFromSignal(sourceSignal: Signal) {
    sourceSignal.groupAddresses.forEach((sourceGroupAddress) => {
      this.connectWithGroupAddress(sourceGroupAddress);
    });
  }

  connectWithGroupAddress(groupAddress: GroupAddress): boolean {
    if (!(this.parent as BaseModel)?.isConsumer) {
      (this.parent as Channel).assetIsRequestChannel();
    }

    if (this.groupAddresses.add(groupAddress)) {
      // ga need to be set as manual connected, because it is not a normal connection via the channel
      groupAddress.isManualConnected = true;
      groupAddress.raiseOnChange("signalBackpointer");
      groupAddress.raiseOnChangeUI("childCollection");

      this.raiseOnChangeUI("childCollection");
      // Notify parent channel's signals map so OneChannel re-renders and recalculates usedSortedSignals
      if (!(this.parent as BaseModel)?.isConsumer) {
        (this.parent as Channel).raiseOnChange("childCollection");
        (this.parent as Channel).mappedChannel?.raiseOnChange("childCollection");
      }

      return true;
    }
    return false;
  }

  get isRequestSignal(): boolean {
    return (this.parent as Channel).isRequestChannel;
  }

  get isLogicSignal(): boolean {
    return (this.parent as Channel).isLogicChannel;
  }

  connectWith(obj: BaseModel): boolean {
    if (!this.isRequestSignal) {
      return this.requestSignal?.connectWith(obj) || false;
    }

    switch (obj.className) {
      case noItx("Signal"):
        let signal2 = (obj as Signal).requestSignal;
        if (signal2 && signal2 != this) {
          // open here Dialog to check if user wants to create a new group address or use an existing one
          showSignalConnectionDialog(signal2, this);
          return true;
        }
        break;

      case noItx("GroupAddress"):
        const res = this.connectWithGroupAddress(obj as GroupAddress);
        if (res) {
          this.addManualGroupAddress(obj as GroupAddress);
          ensureSignalInManualChannel(this.parent?.parent as Device, this);

          return true;
        }
    }

    return false;
  }

  createAndConnectWithNewGroupAddress(signal2: Signal): GroupAddress | undefined {
    const thisDevice = this.parent?.parent;
    const objDevice = signal2.parent?.parent;
    let res: GroupAddress | undefined;

    //
    // MWE 2.12.2025 wir erlauben ab jetzt Verbindungen innerhalb eines Gerätes
    //
    // if (this.parent == signal2.parent) {
    //   break;
    // }

    const createLogicGroupAddress = signal2.isLogicSignal || this.isLogicSignal;
    const createDevieInternalGroupAddress = thisDevice == objDevice;

    const a2 = createLogicGroupAddress ? "3" : "2";

    let manualGroup = state.addresses.findFirst((a) => a.address == "31")?.children.findFirst((a) => a.address == a2);

    if (!manualGroup) {
      createGlobalAddresses(state.settings.knxGroupAddressGeneneration);
      manualGroup = state.addresses.findFirst((a) => a.address == "31")?.children.findFirst((a) => a.address == a2);
    }

    if (manualGroup) {
      const thisPart = this.parent?.parent?.tag + ":" + this.number + " " + (this.parent as Channel)?.shortName; // no itx
      const otherPart =
        signal2.parent?.parent?.tag + ":" + (signal2 as Signal).number + " " + (signal2.parent as Channel).shortName; // no itx

      const signalType = descriptionForSignalType(this.type);

      const name = thisPart + " - " + otherPart + "  " + signalType;

      const newGroupAddress = GroupAddress.createNewGroupAddress({
        parent: manualGroup,
        level: 3,
        name: name,
      });

      if (createLogicGroupAddress) {
        if (thisDevice == objDevice) {
          newGroupAddress.name = `${thisDevice?.fullTag}: State ${newGroupAddress.address}`;
        } else {
          newGroupAddress.name = `State ${newGroupAddress.address}`;
        }
      }

      newGroupAddress.updateFullAddress();

      const res2 = signal2.addManualGroupAddress(newGroupAddress);
      const res1 = this.addManualGroupAddress(newGroupAddress);
      // Notify the group address tree so the new GA becomes visible
      manualGroup.children.raiseOnChange("childCollection");
      // notify parent channel
      this.parent?.raiseOnChange("childCollection");
      newGroupAddress.raiseOnChange("signalBackpointer");
      newGroupAddress.raiseOnChangeUI("childCollection");

      this.raiseOnChangeUI("childCollection");
      signal2.raiseOnChangeUI("childCollection");

      if (res1 && res2) {
        ensureSignalInManualChannel(this.parent?.parent as Device, this);
        ensureSignalInManualChannel(signal2.parent?.parent as Device, signal2);
      }
    }
    return res;
  }

  get onlyOneGroupAddressAllowed(): boolean {
    let res = false;
    let channel = this.parent as Channel;
    if ((channel?.isActorChannel && this.type.isStatus) || (channel?.isButtonChannel && !this.type.isStatus)) {
      res = true;
    }
    return res;
  }

  addManualGroupAddress(newGroupAddress: GroupAddress): boolean {
    newGroupAddress.isManualConnected = true;
    return this.addGroupAddress(newGroupAddress);
  }

  removeManualGroupAddress(groupAddress: GroupAddress) {
    this.removeGroupAddress(groupAddress);
  }

  removeAllGroupAddress(exceptOfManual: boolean) {
    let changed = false;

    this.groupAddresses.referencedIds.forEach((refId) => {
      let ga = state.objectRegistry.getObject(refId) as GroupAddress | undefined;
      if (ga && !ga.parent) {
        logger.error(`removeAllGroupAddress: GA has no parent: ${ga.fullAddress}`);
        ga = undefined;
      } else {
        if (ga?.isDeleted) {
          logger.error(`removeAllGroupAddress: GA is deleted: ${ga.fullAddress}`);
          ga = undefined;
        }
      }

      if (ga) {
        if (isDevelopmentEnvironment()) {
          ga.checkParentConsistency();
        }

        if (!exceptOfManual || !ga.isManualGroupAddress) {
          this.groupAddresses.removeId(refId);
          changed = true;
        }
      } else {
        this.groupAddresses.removeId(refId);
        changed = true;
      }
    });

    this.groupAddresses.forEach((ga) => {
      if (!exceptOfManual || !ga.isManualGroupAddress) {
        this.removeGroupAddress(ga);
        changed = true;
      }
    });

    if (changed) {
      this.raiseOnChange("groupAddresses");
    }
  }

  datapointTypeSize(): number {
    let res = 0;
    const datapointType = this.knxDatapointType.toLocaleLowerCase();

    const dptsMap: { [key: string]: number | undefined } = {
      "dpts-1": 1,
      "dpts-2": 2,
      "dpts-3": 4,
      "dpts-4": 8,
      "dpts-5": 8,
      "dpts-6": 8,
      "dpts-7": 16,
      "dpts-8": 16,
      "dpts-9": 16,
      "dpts-10": 24,
      "dpts-11": 24,
      "dpts-12": 32,
      "dpts-13": 32,
      "dpts-14": 32,
      "dpts-15": 32,
      "dpts-16": 112,
      "dpts-17": 8,
      "dpts-18": 8,
      "dpts-19": 64,
      "dpts-20": 8,
      "dpts-21": 8,
      "dpts-22": 16,
      "dpts-23": 24,
      "dpts-24": 312,
      "dpts-25": 8,
      "dpts-26": 8,
      "dpts-27": 32,
      "dpts-28": 312,
      "dpts-29": 64,
      "dpts-30": 24,
      "dpts-206": 16,
      "dpts-207": 8,
      "dpts-217": 48,
      "dpts-219": 16,
      "dpts-222": 48,
      "dpts-225": 24,
      "dpts-229": 48,
      "dpts-230": 64,
      "dpts-232": 24,
      "dpts-234": 16,
      "dpts-235": 48,
      "dpts-236": 8,
      "dpts-237": 16,
      "dpts-238": 8,
      "dpts-240": 24,
      "dpts-241": 32,
      "dpts-242": 48,
      "dpts-244": 16,
      "dpts-245": 48,
      "dpts-246": 16,
      "dpts-249": 48,
      "dpts-250": 24,
      "dpts-251": 48,
      "dpts-252": 40,
      "dpts-254": 24,
      "dpts-255": 64,
      "dpts-275": 64,
      ////////////////////
      "@ 1 bit": 1,
      "@ 2 bit": 2,
      "@ 4 bit": 4,
      "@ 8 bit": 8,
      ////////////////
      "@ 1 byte": 8,
      "@ 2 byte": 16,
      "@ 3 byte": 24,
      "@ 4 byte": 32,
    };

    if (datapointType.indexOf("byte") >= 0) {
      // byte in dpt
      const numberString = datapointType.replace("byte", "").trim();
      const number = parseInt(numberString);
      if (!isNaN(number)) {
        res = number * 8;
      } else {
        logger.error(`Could not parse byte size from datapoint type: ${this.knxDatapointType}`);
      }
    } else if (datapointType.indexOf("bit") >= 0) {
      // bit in dpt
      const numberString = datapointType.replace("bit", "").trim();
      const number = parseInt(numberString);
      if (!isNaN(number)) {
        res = number;
      } else {
        logger.error(`Could not parse bit size from datapoint type: ${this.knxDatapointType}`);
      }

      res = 1;
    } else if (datapointType.indexOf("dpst") >= 0) {
      // standard datapoint type
      const dpst = datapointType.replace("dpst", "").trim();
      const parts = dpst.split("-");
      if (parts.length == 2) {
        const size = dptsMap["dpts-" + parts[0]];
        if (size) {
          res = size;
        } else {
          logger.error(`Unknown DPT size for datapoint type: ${this.knxDatapointType}`);
        }
      }
    }
    return res;
  }

  cleanDatapointType() {
    if (!this.knxDatapointType && this.a?.ObjectSize) {
      var objectSize = this.a.ObjectSize;
      if (objectSize == "1 Bit") {
        this.knxDatapointType = "DPST-1-1";
      } else {
        this.knxDatapointType = "@ " + objectSize;
      }
      return;
    }

    let datapointType = this.knxDatapointType.toLocaleLowerCase();

    if (datapointType.indexOf("byte") >= 0 || datapointType.indexOf("bit") >= 0) {
      return;
    }

    //
    // fix "dpt-1 dpt-1" from Albrecht Jung / 5073TSM
    //
    const cleanDatapointType = datapointType.split(" ");
    datapointType = cleanDatapointType[0];

    //
    // fix "dpt-1"  to "dpst-1"  from Albrecht Jung / 5073TSM
    //

    datapointType = datapointType.replace("dpt", "dpst");

    //
    // fix "dpt-1"  to "dpt-1-1"  from Albrecht Jung / 5073TSM
    //
    const parts = datapointType.split("-");
    if (parts.length == 2) {
      datapointType += "-1";
    }

    this.knxDatapointType = datapointType;
  }

  addGroupAddress(groupAddress: GroupAddress): boolean {
    groupAddress.addSignalBackpointer(this);
    return this.groupAddresses.add(groupAddress);
  }

  removeGroupAddress(groupAddress: GroupAddress, withUndo = false): boolean {
    if (this.groupAddresses.items.includes(groupAddress)) {
      groupAddress.removeSignalBackpointer(this);
      this.groupAddresses.remove(groupAddress);
      // Notify the signal so OneSignal/SignalGroupAddresses re-renders the updated GA list.
      this.raiseOnChangeUI("childCollection");
      // Also notify the device-level channels map so KnxButtonTable re-renders
      // when the signal disappears from the "Manuell verbundene Signale" section.
      if (!(this.parent as BaseModel)?.isConsumer) {
        ((this.parent as Channel).parent as Device)?.channels?.raiseOnChangeUI?.();
      }
      if (withUndo) {
      }
      return true;
    } else {
      return false;
    }
  }

  setSingleGroupAddress(groupAddress: GroupAddress) {
    this.groupAddresses.clear();
    this.groupAddresses.add(groupAddress);
  }

  getLastGroupAddressBySignalType(signalType: SignalType): GroupAddress | undefined {
    return this.lastGroupAddresses?.find((ga) => ga.signalTypeName == signalType.name);
  }

  matchTextForMatchType(type: MatchType): string {
    switch (type) {
      case MatchType.Text:
        return this.knxTextENForDetection || "";

      case MatchType.Raw:
        return this.knxTextENForDetectionRaw + " |f " + this.knxFunctionTextEN + " |t " + this.a?.DatapointType || "";

      case MatchType.Display:
        return this.name + " |f " + this.knxFunctionTextEN + " |t " + this.a?.DatapointType || "";

      case MatchType.Full:
      default:
        return this.knxTextENForDetection + " |f " + this.knxFunctionTextEN + " |t " + this.a?.DatapointType || "";
    }
  }

  //
  // Alle Signale die mit einer irgendeiner Gruppenadressen dieses Signals verbunden sind
  //
  allConnectedSignalsViaGroupAddresses(
    hardwareSignalsOnly?: boolean,
    groupAddressFilter?: (ga: GroupAddress) => boolean,
  ): Array<Signal> {
    const res = new Set<Signal>();
    this.groupAddresses.items.forEach((ga) => {
      ga.getSignalBackpointers(hardwareSignalsOnly).forEach((signal) => {
        if (!groupAddressFilter || groupAddressFilter(ga)) {
          res.add(signal);
        }
      });
    });
    return [...res];
  }

  //
  // Sammle alle über die Gruppenadressen verbundenen Actor-Kanäle
  //
  connectedActorChannelsViaGroupaddresses(groupAddressFilter?: (ga: GroupAddress) => boolean): Array<Channel> {
    const res = new Set<Channel>();

    for (const signal of this.allConnectedSignalsViaGroupAddresses(true, groupAddressFilter)) {
      if ((signal?.parent as BaseModel)?.isChannel && (signal?.parent as Channel)?.isActorChannel) {
        res.add(signal.parent as Channel);
      }
    }

    return [...res];
  }

  //
  // Sammle alle über die Gruppenadressen verbundenen Consumer
  //

  connectedConsumersViaGroupaddresses(groupAddressFilter?: (ga: GroupAddress) => boolean): Array<Consumer> {
    const res = new Set<Consumer>();

    for (const signal of this.allConnectedSignalsViaGroupAddresses(false, groupAddressFilter)) {
      if ((signal?.parent as BaseModel)?.isConsumer) {
        res.add(signal.parent as Consumer);
      }
    }

    return [...res];
  }

  consistencyCheck(parent: BaseModel) {
    super.consistencyCheck(parent);

    this.groupAddresses.consistencyCheck(this);
    // to check if old error for too many group addresses exists and clear it
    if (this.errors?.toMuchGroupAdresses) {
      this.flagErrors({ toMuchGroupAdresses: "" }, false);
    }
  }
}
